import { LOCALE } from './consts/strings';
import { isNumericString, parseNumber } from './parseNumber';

export function formatNumber(
  value: string | number,
  options?: Intl.NumberFormatOptions
): string {
  return !isNumericString(value)
    ? (value as string)
    : Number(parseNumber(value as string)).toLocaleString(LOCALE, options);
}
